import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { groupTargetsForSelect } from '../utils/targetTreeUtils';

/**
 * Renders a <select> with <optgroup> when targets contain hierarchical names (with `/`).
 * Falls back to a flat <select> when no hierarchy is detected.
 */
const TargetSelect = ({ targets, value, onChange, className = undefined }) => {
  const grouped = useMemo(() => groupTargetsForSelect(targets), [targets]);
  const hasGroups = Object.keys(grouped.groups).length > 0;

  if (!hasGroups) {
    return (
      <select
        className={className}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        title={value}
      >
        {targets.map(t => (
          <option key={t.name} value={t.name}>{t.name}</option>
        ))}
      </select>
    );
  }

  return (
    <select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      title={value}
    >
      {grouped.ungrouped.map(t => (
        <option key={t.name} value={t.name}>{t.displayName}</option>
      ))}
      {Object.entries(grouped.groups).map(([group, items]) => (
        <optgroup key={group} label={group}>
          {items.map(t => (
            <option key={t.name} value={t.name}>{t.displayName}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
};

TargetSelect.propTypes = {
  targets: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};


export default TargetSelect;
